import React, { useContext, useRef, useState } from 'react';
import { SystemSettingsContext } from '../../../contexts/SystemSettingsContext';
import { ScrollableArea, ScrollbarSvg } from '@adserve/adserve-react-components';
import {
    forwardScheduleContainerStyle,
    forwardScheduleTableStyle,
    forwardScheduleHeadCellStyle,
    forwardScheduleTextStyle,
    forwardScheduleMainCellStyle,
    invoiceNumberTextStyle,
    scheduleScrollbarStyle
} from './BillingStyles';
import ForwardSchedulePoNumber from './ForwardSchedulePoNumber';

const BillingForwardSchedule = ({ campaign, tableData = [], setForwardScheduleDetails, setShowForwardScheduleDetails, loadData, readOnly = false }) => {
    let scheduledAirtime = 0;
    let scheduledOffairs = 0;
    let scheduledCommission = 0;
    let scheduledVat = 0;
    let scheduledTotal = 0;
    const { formatCurrency } = useContext(SystemSettingsContext);
    const invoicesScrollRef = useRef(null);
    const [invoicesScrollPx, setInvoicesScrollPx] = useState(0);

    const handleScroll = (val) => {
        setInvoicesScrollPx(val);
        invoicesScrollRef?.current?.scroll(0, val);
    };

    const handleCellClick = (payload) => {
        setForwardScheduleDetails(payload);
        setShowForwardScheduleDetails(true);
    };

    return (
        <div style={forwardScheduleContainerStyle}>
            <div
                style={{
                    position: 'absolute',
                    height: 1,
                    width: 1791,
                    backgroundColor: '#D7D7D7'
                }}
            />
            <div
                style={{
                    position: 'absolute',
                    marginTop: 41,
                    height: 1,
                    width: 1791,
                    backgroundColor: '#D7D7D7'
                }}
            />
            <div
                style={{
                    position: 'absolute',
                    marginTop: 40,
                    height: 1,
                    width: 1791,
                    backgroundColor: 'white'
                }}
            />
            <ScrollableArea
                id={'forward-schedule-container'}
                ref={invoicesScrollRef}
                style={{ width: '100%', height: 287, overflow: 'hidden' }}
                scrollSpeed={8}
                scrollPx={invoicesScrollPx}
                onScroll={handleScroll}
                scrollableLength={invoicesScrollRef?.current?.scrollHeight || 244}
                maxVisibleLength={244}
            >
                <div style={scheduleScrollbarStyle}>
                    {tableData?.length > 7 && (
                        <ScrollbarSvg
                            scrollPx={invoicesScrollPx}
                            onScroll={handleScroll}
                            maxVisibleLength={244}
                            gutterOffset={860}
                            scrollableLength={invoicesScrollRef?.current?.scrollHeight || 244}
                            disabled={false}
                        />
                    )}
                </div>
                <table style={forwardScheduleTableStyle}>
                    <thead>
                        <tr>
                            <th
                                style={{
                                    ...forwardScheduleHeadCellStyle,
                                    width: 170
                                }}
                            >
                                <span style={forwardScheduleTextStyle}>{window.translate('Invoice Number')}</span>
                            </th>

                            <th
                                style={{
                                    ...forwardScheduleHeadCellStyle,
                                    width: 143
                                }}
                            >
                                <span style={forwardScheduleTextStyle}>{window.translate('Invoice Start Date')}</span>
                            </th>

                            <th
                                style={{
                                    ...forwardScheduleHeadCellStyle,
                                    width: 155
                                }}
                            >
                                <span style={forwardScheduleTextStyle}>{window.translate('Invoice End Date')}</span>
                            </th>

                            <th
                                style={{
                                    ...forwardScheduleHeadCellStyle,
                                    width: 197
                                }}
                            >
                                <span style={forwardScheduleTextStyle}>
                                    {window.translate('Purchase Order Number')}
                                </span>
                            </th>

                            <th
                                style={{
                                    ...forwardScheduleHeadCellStyle,
                                    width: 150
                                }}
                            >
                                <span style={forwardScheduleTextStyle}>{window.translate('Est. Airtime')}</span>
                            </th>

                            <th
                                style={{
                                    ...forwardScheduleHeadCellStyle,
                                    width: 150
                                }}
                            >
                                <span style={forwardScheduleTextStyle}>{window.translate('Est. Off-Airs')}</span>
                            </th>

                            <th
                                style={{
                                    ...forwardScheduleHeadCellStyle,
                                    width: 155
                                }}
                            >
                                <span style={forwardScheduleTextStyle}>{window.translate('Est. Commission')}</span>
                            </th>

                            <th
                                style={{
                                    ...forwardScheduleHeadCellStyle,
                                    width: 155
                                }}
                            >
                                <span style={forwardScheduleTextStyle}>{window.translate('VAT')}</span>
                            </th>

                            <th
                                style={{
                                    ...forwardScheduleHeadCellStyle,
                                    width: 156
                                }}
                            >
                                <span style={forwardScheduleTextStyle}>{window.translate('Total')}</span>
                            </th>

                            <th
                                style={{
                                    ...forwardScheduleHeadCellStyle,
                                    width: 145
                                }}
                            >
                                <span style={forwardScheduleTextStyle}>{window.translate('Exp. Issue Date')}</span>
                            </th>

                            <th
                                style={{
                                    ...forwardScheduleHeadCellStyle,
                                    width: 225
                                }}
                            >
                                <span style={forwardScheduleTextStyle}>{window.translate('Authorised By')}</span>
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        {tableData?.map((fs, i) => {
                            scheduledAirtime += fs?.airtimeValue;
                            scheduledOffairs += fs?.offAirsValue;
                            scheduledCommission += fs?.commission;
                            scheduledVat += fs?.vatValue;
                            scheduledTotal += fs?.total;
                            return (
                                <tr key={`forward-schedule-row-${i}`}>
                                    <td align='right' style={{...forwardScheduleMainCellStyle(i),
                                        cursor: 'pointer'}} onClick={() =>
                                        handleCellClick(fs)
                                    }>
                                        <span style={invoiceNumberTextStyle()}>{fs?.status}</span>
                                    </td>
                                    <td align='right' style={forwardScheduleMainCellStyle(i)}>
                                        <span style={forwardScheduleTextStyle}>{fs?.invoiceDate.substr(0, 10)}</span>
                                    </td>
                                    <td align='right' style={forwardScheduleMainCellStyle(i)}>
                                        <span style={forwardScheduleTextStyle}>{fs?.invoiceEndDate.substr(0, 10)}</span>
                                    </td>
                                    <td align='right' style={{...forwardScheduleMainCellStyle(i), padding: 0 }}>
                                        <ForwardSchedulePoNumber billingPlanInvoice={fs} campaignId={campaign.id} getData={loadData} readOnly={readOnly} />
                                    </td>
                                    <td align='right' style={forwardScheduleMainCellStyle(i)}>
                                        <span style={forwardScheduleTextStyle}>{formatCurrency(fs?.airtimeValue)}</span>
                                    </td>
                                    <td align='right' style={forwardScheduleMainCellStyle(i)}>
                                        <span style={forwardScheduleTextStyle}>{formatCurrency(fs?.offAirsValue)}</span>
                                    </td>
                                    <td align='right' style={forwardScheduleMainCellStyle(i)}>
                                        <span style={forwardScheduleTextStyle}>{formatCurrency(fs?.commission)}</span>
                                    </td>
                                    <td align='right' style={forwardScheduleMainCellStyle(i)}>
                                        <span style={forwardScheduleTextStyle}>{formatCurrency(fs?.vatValue)}</span>
                                    </td>
                                    <td align='right' style={forwardScheduleMainCellStyle(i)}>
                                        <span style={forwardScheduleTextStyle}>{formatCurrency(fs?.total)}</span>
                                    </td>
                                    <td align='right' style={forwardScheduleMainCellStyle(i)}>
                                        <span style={forwardScheduleTextStyle}>{fs?.issueDate.substr(0, 10)}</span>
                                    </td>
                                    <td align='right' style={forwardScheduleMainCellStyle(i)}>
                                        <span style={forwardScheduleTextStyle}>{tableData[i]?.authorisedBy}</span>
                                    </td>
                                </tr>
                            );
                        })}
                        {Object.keys(tableData)?.length < 5
                            ? Array.apply(null, Array(5 - Object.keys(tableData)?.length))
                                .map(function () {
                                    return {};
                                })
                                .map((dp, j) => (
                                    <tr key={`invoices-issued-${j}`}>
                                        <td align='right' style={forwardScheduleMainCellStyle(j)}></td>
                                        <td align='right' style={forwardScheduleMainCellStyle(j)}></td>
                                        <td align='right' style={forwardScheduleMainCellStyle(j)}></td>
                                        <td align='right' style={forwardScheduleMainCellStyle(j)}></td>
                                        <td align='right' style={forwardScheduleMainCellStyle(j)}></td>
                                        <td align='right' style={forwardScheduleMainCellStyle(j)}></td>
                                        <td align='right' style={forwardScheduleMainCellStyle(j)}></td>
                                        <td align='right' style={forwardScheduleMainCellStyle(j)}></td>
                                        <td align='right' style={forwardScheduleMainCellStyle(j)}></td>
                                        <td align='right' style={forwardScheduleMainCellStyle(j)}></td>
                                        <td align='right' style={forwardScheduleMainCellStyle(j)}></td>
                                    </tr>
                                ))
                            : null}
                    </tbody>
                </table>
            </ScrollableArea>
            <div
                style={{
                    display: 'flex',
                    flexBasis: 1,
                    width: 1857,
                    marginTop: -1
                }}
            >
                <div
                    align='right'
                    style={{
                        ...forwardScheduleMainCellStyle(1),
                        paddingRight: 11,
                        width: 169,
                        paddingTop: 10
                    }}
                >
                    {window.translate('Total to Invoice')}
                </div>
                <div
                    align='right'
                    style={{
                        ...forwardScheduleMainCellStyle(1),
                        paddingRight: 11,
                        width: 143,
                        marginLeft: -1,
                        paddingTop: 10
                    }}
                />
                <div
                    align='right'
                    style={{
                        ...forwardScheduleMainCellStyle(1),
                        paddingRight: 11,
                        width: 155,
                        marginLeft: -1,
                        paddingTop: 10
                    }}
                />
                <div
                    align='right'
                    style={{
                        ...forwardScheduleMainCellStyle(1),
                        paddingRight: 11,
                        width: 197,
                        marginLeft: -1,
                        paddingTop: 10
                    }}
                />
                <div
                    align='right'
                    style={{
                        ...forwardScheduleMainCellStyle(1),
                        paddingRight: 11,
                        width: 150,
                        marginLeft: -1,
                        paddingTop: 10
                    }}
                >
                    {formatCurrency(scheduledAirtime) || '£0.00'}
                </div>
                <div
                    align='right'
                    style={{
                        ...forwardScheduleMainCellStyle(1),
                        paddingRight: 11,
                        width: 150,
                        marginLeft: -1,
                        paddingTop: 10
                    }}
                >
                    {formatCurrency(scheduledOffairs) || '£0.00'}
                </div>
                <div
                    align='right'
                    style={{
                        ...forwardScheduleMainCellStyle(1),
                        paddingRight: 11,
                        width: 156,
                        marginLeft: -1,
                        paddingTop: 10
                    }}
                >
                    {formatCurrency(scheduledCommission) || '£0.00'}
                </div>
                <div
                    align='right'
                    style={{
                        ...forwardScheduleMainCellStyle(1),
                        paddingRight: 11,
                        width: 155,
                        marginLeft: -1,
                        paddingTop: 10
                    }}
                >
                    {formatCurrency(scheduledVat) || '£0.00'}
                </div>
                <div
                    align='right'
                    style={{
                        ...forwardScheduleMainCellStyle(1),
                        paddingRight: 11,
                        width: 156,
                        marginLeft: -1,
                        paddingTop: 10
                    }}
                >
                    {formatCurrency(scheduledTotal) || '£0.00'}
                </div>
                <div
                    align='right'
                    style={{
                        ...forwardScheduleMainCellStyle(1),
                        paddingRight: 29,
                        width: 145,
                        marginLeft: -1,
                        paddingTop: 10
                    }}
                />
                <div
                    align='right'
                    style={{
                        ...forwardScheduleMainCellStyle(1),
                        paddingRight: 29,
                        width: 225,
                        marginLeft: -1,
                        paddingTop: 10
                    }}
                />
            </div>
        </div>
    );
};

export default BillingForwardSchedule;
